/* eslint-disable import/no-cycle */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box } from '@material-ui/core';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import AccountInvoiceBalanceFilters from './components/AccountInvoiceBalanceList/AccountInvoiceBalanceFilters';
import { AccountInvoiceBalanceListContext } from './components/AccountInvoiceBalanceList/AccountInvoiceBalanceProvider';
import AccountStatementSummary from './components/AccountInvoiceBalanceList/AccountStatementSummary';
import AccountStatementList from './components/AccountInvoiceBalanceList/AccountStatementList';
import { getQueryUrl } from '../../services/provider/dataProvider';
import resourceSlug from '../../constant/resource-slug';
import { clearDateRangePrefix, sanitizeObject } from '../../services/util';

const AccountInvoiceBalanceList = (props) => {
  const query = useQueryParams();

  const appliedFilters = useMemo(() => {
    const [fromTime, toTime] = clearDateRangePrefix(query.time || '')?.split(',') || [];
    return sanitizeObject({
      groupId: query.groupId,
      fromTime: Number.isNaN(+fromTime) ? undefined : +fromTime,
      toTime: Number.isNaN(+toTime) ? undefined : +toTime,
    });
  }, [query]);

  const [perPage, setPerPage] = useState(query?.perPage || 25);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(Object.keys(query)?.length));

  const handleFetchData = useCallback(
    async (url) => {
      try {
        setLoading(true);
        setData({});
        const response = await axios.get(url);
        setData(response.data.data);
      } catch (error) {
        console.log(error);
        setData({});
      } finally {
        setLoading(false);
      }
    },
    [setLoading, setData],
  );

  useEffect(() => {
    if (query.groupId && query.time) {
      const { url } = getQueryUrl(resourceSlug.ACCOUNT_STATEMENT, {
        filter: appliedFilters,
      });
      handleFetchData(url);
    }
  }, [appliedFilters]);

  return (
    <AccountInvoiceBalanceListContext.Provider
      value={{
        query,
        appliedFilters,
        data,
        setData,
        setPerPage,
        perPage,
        loading,
        setLoading,
      }}
    >
      <AccountInvoiceBalanceFilters />
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          gap: 24,
        }}
      >
        <AccountStatementSummary />
        <AccountStatementList {...props} />
      </Box>
    </AccountInvoiceBalanceListContext.Provider>
  );
};

export default AccountInvoiceBalanceList;

const useQueryParams = () => {
  const { search } = useLocation();

  return useMemo(
    () =>
      queryString.parse(search, {
        arrayFormat: 'index',
      }),
    [search],
  );
};
